import type {LocationQueryRaw, RouteLocationRaw} from "vue-router"
import router from "@/router"

export default function routeTo(name: string, params: {
  [p: string]: string | string[] | number | number[]
} = {}, query: LocationQueryRaw = {}): RouteLocationRaw {
  const routes = router.options!.routes!.map((route) => [route, ...route.children || []]).flat()
  const route = routes.find((route) => route.name === name)
  if (!route) {
    // eslint-disable-next-line no-console
    console.error(`Route ${name} not found`)
    return {name: "not-found", params: {catchAll: name}}
  }
  return {name, params, query}
}
